import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const MeIntegrationsRedirect: React.FC = () => {
  const location = useLocation();
  const search = location.search ? location.search : '';
  return <Navigate to={`/learn/calendar${search}`} replace />;
};

export default MeIntegrationsRedirect;
